import axios from 'axios';
import { downloadFile } from 'app/api/apiUtil';

const api = '/api/upomienky';

export const prepareUpomienky = () => axios.post(`${api}/prepare`);

export const downloadUpomienkaPdf = async (id: number) => {
  const response = await axios.get(`${api}/${id}/pdf?cacheBuster=${new Date().getTime()}`, { responseType: 'blob' });
  downloadFile(response);
};

export const downloadUpomienkaDocx = async (id: number) => {
  const response = await axios.get(`${api}/${id}/docx?cacheBuster=${new Date().getTime()}`, { responseType: 'blob' });
  downloadFile(response);
};

export const markUpomienkaSent = (id: number, email?: string) => axios.post(`${api}/${id}/send`, { email });

export const cancelUpomienka = (id: number) => axios.post(`${api}/${id}/cancel`);

export const sendUpomienkaEmail = (id: number, email: string, subject: string, message: string) =>
  axios.post(`${api}/${id}/email`, { email, subject, message });

export const sendUpomienkaEmailBulk = (ids: number[], subject: string, message: string) =>
  axios.post(`${api}/email-bulk`, { ids, subject, message });
